import moment from 'moment'
import isUndefined from 'lodash/isUndefined'
import toString from 'lodash/toString'
import findIndex from 'lodash/findIndex'
import reduce from 'lodash/reduce'
import toArray from 'lodash/toArray'
import find from 'lodash/find'
import isNull from 'lodash/isNull'
import isArray from 'lodash/isArray'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import { LKDate } from 'loankeeper-common/helpers/Date'
import { DAYS_PER_MONTH_AVG } from '../constants'
import { getInitialValues } from '../../../DynamicFields'

import { 
  DropdownItem,
  GeneralLookupTypes, 
  LoanOfficersObj, 
  LoanOfficers, 
  GetFormAndAdditionalInitialValuesAddInitial,
  GetFormAndAdditionalInitialValuesAddAdditional,
  getFormAndAdditionalInitialValuesEditInitial,
  getFormAndAdditionalInitialValuesEditAdditional
} from '../types.applicationFactory'

import { 
  ProductDetailsServerData, 
  Currency, 
  ApplicationAddListMainType,
  ApplicationAddListReduced
} from '@lk/api'

export const isClientViewBaseValidTest = (clientValidation: any) => isArray(clientValidation) && isEmpty(clientValidation)

export const isApplicationIdentity = (applicationIdentity: any) => !isUndefined(applicationIdentity)

export const isDropdownDisabled = (options: DropdownItem[]) => isEmpty(options) || options.length === 1

export const getDropdownFirstValue = (options: DropdownItem[], secondIfExists?: boolean): string | number => 
  get(options, options.length > 1 && secondIfExists ? '[1].value' : '[0].value')

export const isProductViewListValid = (productViewList: any) => isArray(productViewList) && !isEmpty(productViewList)

export const isProductViewDetailValid = (productViewDetail: ProductDetailsServerData, ProductID: string | number) =>
 productViewDetail && productViewDetail.ID === ProductID

export const getIndustrySubIDOptionsSource = (generalLookupsSys: GeneralLookupTypes, industryIDVal) => {
  const { IndustrySub } = generalLookupsSys

  //@ts-ignore
  const subs = IndustrySub.filter((s) => s.ORG_IndustryID === industryIDVal)

  if (!subs.some((o) => o.ID === 1)) {
    const notSelected = IndustrySub.find((o) => o.ID === 1)

    if (notSelected) {
      return [notSelected, ...subs]
    }
  }

  return subs
}

export const getIndustrySubDetailOptionsSource = (generalLookupsSys: GeneralLookupTypes, industrySubIDVal) => {
  const { IndustrySubDetail } = generalLookupsSys

  //@ts-ignore
  const subdetail = IndustrySubDetail.filter((sd) => sd.ORG_IndustrySubID === industrySubIDVal)

  if (!subdetail.some((o) => o.ID === 1)) {
    const notSelected = IndustrySubDetail.find((o) => o.ID === 1)

    if (notSelected) {
      return [notSelected, ...subdetail]
    }
  }

  return subdetail
}

export const getIndustrySubIDOptionsFromSource = (industrySubIDOptionsSource: Array<{ID: number | string, Title: string}>) =>
  industrySubIDOptionsSource.map(({ ID, Title }) => ({
    value: ID,
    text: Title,
  }))


export const getIndustrySubDetailOptionsFromSource = (industrySubDetailOptionsSource: Array<{ID: number, Title: string}> |  ApplicationAddListMainType[] | ApplicationAddListReduced[]) =>
  industrySubDetailOptionsSource.map(({ ID, Title }) => ({
    value: ID,
    text: Title,
  }))

export const getReqCurrencyValData = (reqCurrencyOptionsSource: Currency[], reqCurrencyVal: string | number, productViewDetail: ProductDetailsServerData) => {
  const { CCYCheck } = productViewDetail

  return CCYCheck === 1
    ? reqCurrencyOptionsSource.find(({ CCY }) => CCY === reqCurrencyVal)
    : reqCurrencyOptionsSource.find(({ ISO }) => ISO === reqCurrencyVal)
}

export const getReqAmountInitVal = (reqCurrencyValData: Currency, productViewDetail: ProductDetailsServerData) => {
  const { CCYCheck, ProductType } = productViewDetail

  return CCYCheck === 1 && ProductType !== 5 ? reqCurrencyValData.AmountMax : 0
}

export const getReqAmountDisabled = (productViewDetail: ProductDetailsServerData, reqCurrencyValData: Currency) => {
  const { CCYCheck } = productViewDetail
  const { AmountMin, AmountMax } = reqCurrencyValData

  return CCYCheck === 1 && AmountMin === AmountMax
}

export const getReqAmountConfig = (reqAmountDisabled: boolean) => ({ disabled: reqAmountDisabled })

export const getGracePeriodInitVal = (productViewDetail: ProductDetailsServerData) => productViewDetail.GracePeriodMin

export const getGracePeriodIntInitVal = (productViewDetail: ProductDetailsServerData) => productViewDetail.GracePeriodIntMin

export const getGracePeriodInterestAccrualInitVal = (productViewDetail: ProductDetailsServerData) => productViewDetail.GracePeriod_InterestAccrual

export const getPayFreqValueInitVal = (productViewDetail: ProductDetailsServerData) => productViewDetail.PayFreqValue

export const getDurationDaysInitVal = (productViewDetail: ProductDetailsServerData) => productViewDetail.TermDaysMax

export const getDurationDaysFromMonths = (DurationMonths: number) => Math.round(DurationMonths * DAYS_PER_MONTH_AVG)


export const getDurationDays = (Installments, PayFreqPeriod, PayFreqValue) => {
  //nedds checking
  let DurationDays
  if (PayFreqPeriod === 1) {
    DurationDays = Math.round(PayFreqValue * Installments)
  } else if (PayFreqPeriod === 2) {
    DurationDays = Math.round(PayFreqValue * 7 * Installments)
  } else if (PayFreqPeriod === 3) {
    DurationDays = Math.round(PayFreqValue * DAYS_PER_MONTH_AVG * Installments)
  }
  return DurationDays
}

export const getLoanEndDateVal = (openDay: moment.MomentInput, durationDaysVal: moment.DurationInputArg1) =>
  moment(openDay).add(durationDaysVal, 'days').format('DD.MM.YYYY')

export const getDurationMonthsInitVal = (productViewDetail: ProductDetailsServerData) =>
  Math.round(productViewDetail.TermDaysMax / DAYS_PER_MONTH_AVG)

export const getDurationMonthsFromDays = (DurationDays: number) => Math.round(DurationDays / DAYS_PER_MONTH_AVG)

export const getInstallmentsInitVal = (payFreqPeriodVal: number | string, durationDaysVal: number, payFreqValueVal: number) => {
  let installmentsInitVal: number

  if (payFreqPeriodVal === 1) {
    installmentsInitVal = Math.round(durationDaysVal / payFreqValueVal)
  } else if (payFreqPeriodVal === 2) {
    installmentsInitVal = Math.round(durationDaysVal / (payFreqValueVal * 7))
  } else if (payFreqPeriodVal === 3) {
    installmentsInitVal = Math.round(durationDaysVal / (payFreqValueVal * DAYS_PER_MONTH_AVG))
  }

  return installmentsInitVal
}

export const getInterestInitVal = (productViewDetail: ProductDetailsServerData) => productViewDetail.InterestMax

export const getPurposeSumInitVal = (reqAmountVal: number| number) => reqAmountVal

export const getPurpose2SumInitVal = () => '0.0'

export const getContributionInitVal = () => 0

// start: moved from selectors
export const getProductIDOptions = (productViewList: any) => {
  return reduce(
    productViewList,
    (result, { ID, Title }) => [
      ...result,
      {
        value: ID,
        text: Title,
      },
    ],
    [],
  )
}

export const getDurationDaysDisabled = (productViewDetail: ProductDetailsServerData) => {
  const { TermDaysCheck, TermDaysMin, TermDaysMax } = productViewDetail

  return TermDaysCheck === 1 && TermDaysMin === TermDaysMax
}

export const getDurationMonthsDisabled = (productViewDetail: ProductDetailsServerData) => {
  const { TermDaysCheck, TermDaysMin, TermDaysMax } = productViewDetail

  return TermDaysCheck === 1 && TermDaysMin === TermDaysMax
}

export const getInstallmentsDisabled = (productViewDetail: ProductDetailsServerData) => {
  const { TermDaysCheck, TermDaysMin, TermDaysMax } = productViewDetail

  return TermDaysCheck === 1 && TermDaysMin === TermDaysMax
}

export const getDurationDaysConfig = (durationDaysDisabled: boolean) => ({ disabled: durationDaysDisabled })

export const getDurationMonthsConfig = (durationMonthsConfig: boolean) => ({ disabled: durationMonthsConfig })

export const getInstallmentsConfig = (installmentsConfig: boolean) => ({ disabled: installmentsConfig })

export const getGracePeriodDisabled = (productViewDetail: ProductDetailsServerData) => {
  const { GracePeriodCheck, GracePeriodMin, GracePeriodMax } = productViewDetail

  return GracePeriodCheck === 1 && GracePeriodMin === GracePeriodMax
}

export const getGracePeriodIntDisabled = (productViewDetail: ProductDetailsServerData) => {
  const { GracePeriodIntCheck, GracePeriodIntMin, GracePeriodIntMax } = productViewDetail

  return GracePeriodIntCheck === 1 && GracePeriodIntMin === GracePeriodIntMax
}

export const getGracePeriodInterestAccrualDisabled = (productViewDetail: ProductDetailsServerData) => {
  const { GracePeriod_InterestAccrual_Check, GracePeriod_InterestAccrual_Max } = productViewDetail
  const GracePeriod_InterestAccrualMin = productViewDetail.GracePeriod_InterestAccrual

  return GracePeriod_InterestAccrual_Check === 1 && GracePeriod_InterestAccrualMin === GracePeriod_InterestAccrual_Max
}

export const getPayFreqValueDisabled = (productViewDetail: ProductDetailsServerData) => productViewDetail.PayFreqCheck === 1

export const getInterestDisabled = (productViewDetail: ProductDetailsServerData) => {
  const { InterestCheck, InterestMin, InterestMax } = productViewDetail

  return InterestCheck === 1 && InterestMin === InterestMax
}

export const getGracePeriodConfig = (gracePeriodDisabled: boolean) => ({ disabled: gracePeriodDisabled })

export const getGracePeriodIntConfig = (gracePeriodIntDisabled: boolean) => ({ disabled: gracePeriodIntDisabled })

export const getGracePeriodInterestAccrualConfig = (gracePeriodInterestAccrualDisabled: boolean) => ({
  disabled: gracePeriodInterestAccrualDisabled,
})

export const getPayFreqValueConfig = (payFreqValueDisabled: boolean) => ({
  disabled: payFreqValueDisabled,
})

export const getInterestConfig = (interestDisabled: boolean) => ({
  disabled: interestDisabled,
})

export const industrySubIDOptionsExists = (industrySubIDOptions: any) => !isNull(industrySubIDOptions)

export const industrySubIDOptionsSourceExists = (industrySubIDOptionsSource: any) => !isNull(industrySubIDOptionsSource)

export const getPayFreqPeriodOptionsSource = (productViewDetail: ProductDetailsServerData) => {
  const { PayFreqPeriod_LKP, PayFreqCheck, PayFreqPeriodID } = productViewDetail

  let payFreqPeriodOptionsSource = PayFreqPeriod_LKP

  if (PayFreqCheck === 1) {
    payFreqPeriodOptionsSource = [payFreqPeriodOptionsSource.find(({ ID }) => ID === PayFreqPeriodID)]
  }

  return payFreqPeriodOptionsSource
}

export const getPayFreqPeriodOptionsFromSource = (payFreqPeriodOptionsSource: ApplicationAddListMainType[]) =>
  payFreqPeriodOptionsSource.map(({ ID, Title }) => ({
    value: ID,
    text: Title,
  }))

export const getInterestTypeOptionsSource = (productViewDetail: ProductDetailsServerData) => {
  const { Flat_LKP, FlatCheck, Flat } = productViewDetail

  let interestTypeOptionsSource = Flat_LKP
  if (FlatCheck === 1) {
    interestTypeOptionsSource = [interestTypeOptionsSource.find(({ ID }) => ID === Flat)]
  }

  return interestTypeOptionsSource
}

export const getInterestTypeOptionsFromSource = (interestTypeOptionsSource: ApplicationAddListMainType[]) =>
  interestTypeOptionsSource.map(({ ID, Title }) => ({
    value: ID,
    text: Title,
  }))

export const getUpfrontIDOptionsSource = (productViewDetail: ProductDetailsServerData) => {
  const { UpfrontInterest_LKP, UpfrontInterestCheck, UpfrontInterest } = productViewDetail

  let upfrontIDOptionsSource = UpfrontInterest_LKP

  if (UpfrontInterestCheck === 1) {
    upfrontIDOptionsSource = [upfrontIDOptionsSource.find(({ ID }) => ID === UpfrontInterest)]
  }

  return upfrontIDOptionsSource
}

export const getUpfrontIDOptionsFromSource = (upfrontIDOptionsSource: ApplicationAddListMainType[]) =>
  upfrontIDOptionsSource.map(({ ID, Title }) => ({
    value: ID,
    text: Title,
  }))

export const getRevolvingIDOptionsSource = (productViewDetail: ProductDetailsServerData) => {
  const { Revolving_LKP, RevolvingCheck, Revolving } = productViewDetail

  let revolvingIDOptionsSource = Revolving_LKP

  if (RevolvingCheck === 1) {
    revolvingIDOptionsSource = [revolvingIDOptionsSource.find(({ ID }) => ID === Revolving)]
  }

  return revolvingIDOptionsSource
}

export const getRevolvingIDOptionsFromSource = (revolvingIDOptionsSource: ApplicationAddListMainType[]) =>
  revolvingIDOptionsSource.map(({ ID, Title }) => ({
    value: ID,
    text: Title,
  }))

// general

export const getIndustryIDOptionsSource = (productViewDetail: ProductDetailsServerData, generalLookupsSys: GeneralLookupTypes) => {
  const { IndustryCheck } = productViewDetail

  return IndustryCheck === 2 ? generalLookupsSys.Industry : productViewDetail.Industry
}

export const getIndustryIDOptionsFromSource = (industryIDOptionsSource: ApplicationAddListMainType[]) =>
  industryIDOptionsSource.map(({ ID, Title }) => ({
    value: ID,
    text: Title,
  }))

export const getStartupOptions = (generalLookupsSys: GeneralLookupTypes) => {
  const { APP_Startup } = generalLookupsSys

  return APP_Startup.map(({ ID, Title }) => ({ value: ID, text: Title }))
}

export const getRepaymentSourceIDOptions = (generalLookupsSys: GeneralLookupTypes) => {
  const { APP_Repayment_Source } = generalLookupsSys

  return APP_Repayment_Source.map(({ ID, Title }) => ({ value: ID, text: Title }))
}

export const getReqCurrencyOptionsSource = (productViewDetail: ProductDetailsServerData, generalLookupsSys: GeneralLookupTypes) => {
  const { CCYCheck } = productViewDetail

  return CCYCheck === 1 ? productViewDetail.CCY : generalLookupsSys.CCY
}

export const getReqCurrencyOptionsFromSource = (reqCurrencyOptionsSource: Currency[], productViewDetail: ProductDetailsServerData) => {
  const { CCYCheck } = productViewDetail

  return CCYCheck === 1
    ? reqCurrencyOptionsSource.map(({ CCY }) => ({
      value: CCY,
      text: CCY,
    }))
    : reqCurrencyOptionsSource.map(({ ISO }) => ({
      value: ISO,
      text: ISO,
    }))
}

export const getScheduleTypeIDOptionsSource = (productViewDetail: ProductDetailsServerData, generalLookupsSys: GeneralLookupTypes) => {
  const { ScheduleTypeCheck } = productViewDetail

  return ScheduleTypeCheck === 1 ? productViewDetail.ScheduleType : generalLookupsSys.ScheduleType
}

export const getScheduleTypeIDOptionsFromSource = (scheduleTypeIDOptionsSource: ApplicationAddListMainType[]) =>
  scheduleTypeIDOptionsSource.map(({ ID, Title }) => ({
    value: ID,
    text: Title,
  }))

export const getPurposeIDOptionsSource = (productViewDetail: ProductDetailsServerData, generalLookupsSys: GeneralLookupTypes) => {
  const { PurposeCheck, Purpose } = productViewDetail
  const { APP_Purpose } = generalLookupsSys

  return PurposeCheck === 1 ? Purpose : APP_Purpose
}

export const getPurposeIDOptionsFromSource = (purposeIDOptionsSource: ApplicationAddListMainType[]) =>
  purposeIDOptionsSource.map(({ ID, Title }) => ({
    value: ID,
    text: Title,
  }))

export const getPurpose2IDOptionsSource = (productViewDetail: ProductDetailsServerData, generalLookupsSys: GeneralLookupTypes) => {
  const { PurposeCheck, Purpose } = productViewDetail
  const { APP_Purpose2 } = generalLookupsSys

  return PurposeCheck === 1 ? Purpose : APP_Purpose2
}

export const getPurpose2IDOptionsFromSource = (purpose2IDOptionsSource:  ApplicationAddListMainType[]) =>
  purpose2IDOptionsSource.map(({ ID, Title }) => ({
    value: ID,
    text: Title,
  }))

export const getManagerIDOptionsSource = (authorizedUserName: string, activeLoanOfficers: LoanOfficersObj, ManagerID: number) => {
  const activeLoanOfficersArray = toArray(activeLoanOfficers)

  const authorizedUserNameData = find(activeLoanOfficersArray, ({ ID }) => ID === ManagerID)

  return !isUndefined(authorizedUserNameData) ? [authorizedUserNameData] : activeLoanOfficersArray
}

export const getManagerIDOptionsFromSource = (managerIDOptionsSource: LoanOfficers[]) =>
  managerIDOptionsSource.map(({ ID, FullName }) => ({
    value: ID,
    text: FullName,
  }))

// end: moved from selectors

export const getFormAndAdditionalInitialValuesAdd = (paramProps) => {
  const {
    ProductID,
    productIDOptions,
    isClientViewBasePresentAndValid,
    cardNumberInputVal,
    productViewDetail,
    productViewDetail: { DefaultIndustryCheck, DefaultIndustryID },
    generalLookupsSys,
    openDay,
    industryIDOptions,
    startupOptions,
    repaymentSourceIDOptions,
    reqCurrencyOptionsSource,
    reqCurrencyOptions,
    scheduleTypeIDOptions,
    payFreqPeriodOptions,
    interestTypeOptions,
    upfrontIDOptions,
    revolvingIDOptions,
    purposeIDOptions,
    purpose2IDOptions,
    managerIDOptions,
  } = paramProps

  const initialValues: GetFormAndAdditionalInitialValuesAddInitial = {
    ProductID: 0,
    cardNumberInput: '',
    BusinessType: '',
    IndustryID: 0,
    IndustrySubID: 0,
    IndustrySubDetailID: 0,
    Startup: 0,
    RepaymentSourceID: 0,
    OtherPurpose: '',
    OtherPurpose2: '',
    ReqCurrency: '',
    ReqAmount: 0,
    GracePeriod: 0,
    GracePeriodInt: 0,
    GracePeriod_InterestAccrual: 0,
    ScheduleTypeID: 0,
    PayFreqValue: 0,
    PayFreqPeriod: 0,
    DurationDays: 0,
    DurationMonths: 0,
    Installments: 0,
    Interest: 0,
    InterestType: 0,
    UpfrontID: 0,
    RevolvingID: 0,
    PurposeID: 0,
    Purpose2ID: 0,
    PurposeSum: 0,
    Purpose2Sum: '',
    Contribution: 0,
    ManagerID: 0,
    DynFieldData: {
      TTestL: ''
    },
    ProjectDescription: '',
    CField1: '',
    CField2: '',
    CField3: '',
    CField4: ''
  }
  const additionalValues: GetFormAndAdditionalInitialValuesAddAdditional = {
    industrySubIDOptionsSource: [],
    industrySubDetailOptionsSource: [],
    reqCurrencyValData: undefined,
    loanEndDate: ''
  }

  // first page start
  const initProductID = ProductID || getDropdownFirstValue(productIDOptions)
  initialValues.ProductID = initProductID

  initialValues.cardNumberInput =
    isClientViewBasePresentAndValid && !isUndefined(cardNumberInputVal) ? cardNumberInputVal : ''
  initialValues.BusinessType = ''

  initialValues.IndustryID =
    DefaultIndustryCheck === 1 && industryIDOptions.some((o) => o.value === DefaultIndustryID)
      ? DefaultIndustryID
      : getDropdownFirstValue(industryIDOptions, true)

  //@ts-ignore
  additionalValues.industrySubIDOptionsSource = getIndustrySubIDOptionsSource(
    generalLookupsSys,
    initialValues.IndustryID,
  )

  initialValues.IndustrySubID = getDropdownFirstValue(
    getIndustrySubIDOptionsFromSource(additionalValues.industrySubIDOptionsSource),
    true,
  )

  //@ts-ignore
  additionalValues.industrySubDetailOptionsSource = getIndustrySubDetailOptionsSource(
    generalLookupsSys,
    initialValues.IndustrySubID,
  )

  initialValues.IndustrySubDetailID = getDropdownFirstValue(
    getIndustrySubDetailOptionsFromSource(additionalValues.industrySubDetailOptionsSource),
    true,
  )

  initialValues.Startup = getDropdownFirstValue(startupOptions)
  initialValues.RepaymentSourceID = getDropdownFirstValue(repaymentSourceIDOptions)
  // first page end

  // second page start
  initialValues.OtherPurpose = ''
  initialValues.OtherPurpose2 = ''

  initialValues.ReqCurrency = getDropdownFirstValue(reqCurrencyOptions)

  additionalValues.reqCurrencyValData = getReqCurrencyValData(
    reqCurrencyOptionsSource,
    initialValues.ReqCurrency,
    productViewDetail,
  )

  initialValues.ReqAmount = getReqAmountInitVal(additionalValues.reqCurrencyValData, productViewDetail)
  initialValues.GracePeriod = getGracePeriodInitVal(productViewDetail)
  initialValues.GracePeriodInt = getGracePeriodIntInitVal(productViewDetail)
  initialValues.GracePeriod_InterestAccrual = getGracePeriodInterestAccrualInitVal(productViewDetail)
  initialValues.ScheduleTypeID = getDropdownFirstValue(scheduleTypeIDOptions)
  initialValues.PayFreqValue = getPayFreqValueInitVal(productViewDetail)
  initialValues.PayFreqPeriod = getDropdownFirstValue(payFreqPeriodOptions)
  initialValues.DurationDays = getDurationDaysInitVal(productViewDetail)

  additionalValues.loanEndDate = getLoanEndDateVal(openDay, initialValues.DurationDays)

  initialValues.DurationMonths = getDurationMonthsInitVal(productViewDetail)
  initialValues.Installments = getInstallmentsInitVal(
    initialValues.PayFreqPeriod,
    initialValues.DurationDays,
    initialValues.PayFreqValue,
  )
  initialValues.Interest = getInterestInitVal(productViewDetail)
  initialValues.InterestType = getDropdownFirstValue(interestTypeOptions)
  initialValues.UpfrontID = getDropdownFirstValue(upfrontIDOptions)
  initialValues.RevolvingID = getDropdownFirstValue(revolvingIDOptions)
  initialValues.PurposeID = getDropdownFirstValue(purposeIDOptions)
  initialValues.Purpose2ID = getDropdownFirstValue(purpose2IDOptions)
  initialValues.PurposeSum = getPurposeSumInitVal(initialValues.ReqAmount)
  initialValues.Purpose2Sum = getPurpose2SumInitVal()
  initialValues.Contribution = getContributionInitVal()
  initialValues.ManagerID = getDropdownFirstValue(managerIDOptions)
  // second page end

  if (paramProps.dynamicFieldsList) {
    initialValues.DynFieldData = getInitialValues(paramProps.dynamicFieldsList)
  } else {
    initialValues.DynFieldData = undefined
  }

  // fourth page start
  initialValues.ProjectDescription = ''
  initialValues.CField1 = ''
  initialValues.CField2 = ''
  initialValues.CField3 = ''
  initialValues.CField4 = ''
  // fourth page end
  return { initialValues, additionalValues }
}

export const getFormAndAdditionalInitialValuesEdit = (paramProps) => { 
  const {
    appViewBase,
    appViewBase: {
      ProductID,
      BusinessType,
      IndustryID,
      IndustrySubID,
      IndustrySubDetailID,
      StartupID,
      RepaymentSourceID,
      OtherPurpose,
      OtherPurpose2,
      ReqCurrency,
      ReqAmount,
      GracePeriod,
      GracePeriodInt,
      GracePeriod_InterestAccrual,
      ScheduleTypeID,
      Interest,
      InterestTypeID,
      UpfrontID,
      RevolvingID,
      PurposeID,
      Purpose2ID,
      PurposeSum,
      Purpose2Sum,
      Contribution,
      ManagerID,
      ProjectDescription,
      CField1,
      CField2,
      CField3,
      CField4,
      TermDays,
      RegDate,
    },
    productViewDetail,
    productViewDetail: {
      IndustryCheck,
      Industry,
      CCYCheck,
      CCY,
      GracePeriodCheck,
      GracePeriodMin,
      GracePeriodMax,
      GracePeriodIntCheck,
      GracePeriodIntMin,
      GracePeriodIntMax,
      GracePeriod_InterestAccrual_Check,
      GracePeriod_InterestAccrual_Max,
      ScheduleTypeCheck,
      ScheduleType,
      PayFreqCheck,
      InterestCheck,
      InterestMin,
      InterestMax,
      FlatCheck,
      Flat,
      UpfrontInterestCheck,
      UpfrontInterest,
      RevolvingCheck,
      Revolving,
      PurposeCheck,
      Purpose,
      TermDaysCheck,
      TermDaysMin,
      TermDaysMax,
    },
    generalLookupsSys,
    industryIDOptions,
    reqCurrencyOptionsSource,
    reqCurrencyOptions,
    scheduleTypeIDOptions,
    purposeIDOptions,
    purpose2IDOptions,
  } = paramProps
  const GracePeriod_InterestAccrual_Min = productViewDetail.GracePeriod_InterestAccrual

  const PayFreqValueApp = appViewBase.PayFreqValue
  const PayFreqValueProd = productViewDetail.PayFreqValue

  const PayFreqPeriodIDApp = appViewBase.PayFreqPeriodID
  const PayFreqPeriodIDProd = productViewDetail.PayFreqPeriodID

  const getReqAmountRestricted = () => {
    const foundCCY = find(CCY, (nextCCY) => {
      const nxtCCY = nextCCY.CCY

      return nxtCCY === ReqCurrency
    })

    return CCYCheck === 1 && (isUndefined(foundCCY) || foundCCY.AmountMin === foundCCY.AmountMax)
  }

  const getProductRestrictedValRange = (check, min, max, appVal) => {
    if (check === 1) {
      if (min !== max) {
        return appVal
      }

      return max
    }

    return appVal
  }

  const getProductRestrictedVal = (check, prodVal, appVal) => {
    if (check === 1) {
      return prodVal
    }

    return appVal
  }

  const getProdRestrValDropdown = (check, optsSource, opts, keyName, appVal) => {
    if (check === 1) {
      if (
        findIndex(optsSource, (nextOpt) => {
          const nxtOptVal = nextOpt[keyName]

          return nxtOptVal === appVal
        }) !== -1
      ) {
        return appVal
      }

      return getDropdownFirstValue(opts)
    }

    return appVal
  }

  const initialValues: getFormAndAdditionalInitialValuesEditInitial = {
    ProductID: '',
    BusinessType: '',
    IndustryID: '',
    IndustrySubID: '',
    IndustrySubDetailID: '',
    Startup: '',
    RepaymentSourceID: '',
    OtherPurpose: '',
    OtherPurpose2: '',
    ReqCurrency: '',
    ReqAmount: 0,
    GracePeriod: 0,
    GracePeriodInt: 0,
    GracePeriod_InterestAccrual: 0,
    ScheduleTypeID: '',
    PayFreqValue: 0,
    PayFreqPeriod: 0,
    DurationDays: 0,
    DurationMonths: 0,
    Installments: 0,
    Interest: 0,
    InterestType: '',
    UpfrontID: '',
    RevolvingID: '',
    PurposeID: '',
    Purpose2ID: '',
    PurposeSum: 0,
    Purpose2Sum: 0,
    Contribution: 0,
    ManagerID: '',
    DynFieldData: undefined,
    ProjectDescription: '',
    CField1: '',
    CField2: '',
    CField3: '',
    CField4: ''
  }
  const additionalValues: getFormAndAdditionalInitialValuesEditAdditional = {
    industrySubIDOptionsSource: [],
    industrySubDetailOptionsSource: [],
    reqCurrencyValData: undefined,
    loanEndDate: ''
  }

  // first page start
  const initProductID = ProductID
  initialValues.ProductID = initProductID

  initialValues.BusinessType = toString(BusinessType)

  initialValues.IndustryID = getProdRestrValDropdown(IndustryCheck, Industry, industryIDOptions, 'ID', IndustryID)

  //@ts-ignore
  additionalValues.industrySubIDOptionsSource = getIndustrySubIDOptionsSource(
    generalLookupsSys,
    initialValues.IndustryID,
  )

  const getIndustrySubIDInitVal = () => {
    if (initialValues.IndustryID !== IndustryID) {
      return getDropdownFirstValue(getIndustrySubIDOptionsFromSource(additionalValues.industrySubIDOptionsSource), true)
    }

    return IndustrySubID
  }

  initialValues.IndustrySubID = getIndustrySubIDInitVal()

  // subdetail
  //@ts-ignore
  additionalValues.industrySubDetailOptionsSource = getIndustrySubDetailOptionsSource(
    generalLookupsSys,
    initialValues.IndustrySubID,
  )

  const getIndustrySubDetailInitVal = () => {
    if (initialValues.IndustryID !== IndustryID) {
      return getDropdownFirstValue(
        getIndustrySubDetailOptionsFromSource(additionalValues.industrySubDetailOptionsSource),
        true,
      )
    }

    return IndustrySubDetailID
  }
  initialValues.IndustrySubDetailID = getIndustrySubDetailInitVal()
  // end subdetail

  initialValues.Startup = StartupID
  initialValues.RepaymentSourceID = RepaymentSourceID
  // first page end

  // second page start

  initialValues.OtherPurpose = toString(OtherPurpose)
  initialValues.OtherPurpose2 = toString(OtherPurpose2)

  initialValues.ReqCurrency = getProdRestrValDropdown(CCYCheck, CCY, reqCurrencyOptions, 'CCY', ReqCurrency)

  additionalValues.reqCurrencyValData = getReqCurrencyValData(
    reqCurrencyOptionsSource,
    initialValues.ReqCurrency,
    productViewDetail,
  )

  const getReqAmountInitValEdit = () => {
    if (CCYCheck === 1) {
      const foundCCY = find(CCY, (nextCCY) => {
        const nxtCCY = nextCCY.CCY

        return nxtCCY === ReqCurrency
      })

      if (!isUndefined(foundCCY)) {
        if (foundCCY.AmountMin === foundCCY.AmountMax) {
          return foundCCY.AmountMax
        }

        return ReqAmount
      }

      return reqCurrencyOptionsSource[0].AmountMax
    }

    return ReqAmount
  }

  initialValues.ReqAmount = getReqAmountInitValEdit()
  initialValues.GracePeriod = getProductRestrictedValRange(
    GracePeriodCheck,
    GracePeriodMin,
    GracePeriodMax,
    GracePeriod,
  )
  initialValues.GracePeriodInt = getProductRestrictedValRange(
    GracePeriodIntCheck,
    GracePeriodIntMin,
    GracePeriodIntMax,
    GracePeriodInt,
  )
  initialValues.GracePeriod_InterestAccrual = getProductRestrictedValRange(
    GracePeriod_InterestAccrual_Check,
    GracePeriod_InterestAccrual_Min,
    GracePeriod_InterestAccrual_Max,
    GracePeriod_InterestAccrual,
  )
  initialValues.ScheduleTypeID = getProdRestrValDropdown(
    ScheduleTypeCheck,
    ScheduleType,
    scheduleTypeIDOptions,
    'ID',
    ScheduleTypeID,
  )
  initialValues.PayFreqValue = getProductRestrictedVal(PayFreqCheck, PayFreqValueProd, PayFreqValueApp)
  initialValues.PayFreqPeriod = getProductRestrictedVal(PayFreqCheck, PayFreqPeriodIDProd, PayFreqPeriodIDApp)

  initialValues.DurationDays = getProductRestrictedValRange(TermDaysCheck, TermDaysMin, TermDaysMax, TermDays) // this

  additionalValues.loanEndDate = getLoanEndDateVal(RegDate, initialValues.DurationDays)

  initialValues.DurationMonths = getDurationMonthsFromDays(initialValues.DurationDays)

  initialValues.Installments = getInstallmentsInitVal(
    initialValues.PayFreqPeriod,
    initialValues.DurationDays,
    initialValues.PayFreqValue,
  )

  initialValues.Interest = getProductRestrictedValRange(InterestCheck, InterestMin, InterestMax, Interest)

  initialValues.InterestType = getProductRestrictedVal(FlatCheck, Flat, InterestTypeID)

  initialValues.UpfrontID = getProductRestrictedVal(UpfrontInterestCheck, UpfrontInterest, UpfrontID)

  initialValues.RevolvingID = getProductRestrictedVal(RevolvingCheck, Revolving, RevolvingID)

  initialValues.PurposeID = getProdRestrValDropdown(PurposeCheck, Purpose, purposeIDOptions, 'ID', PurposeID)
  initialValues.Purpose2ID = getProdRestrValDropdown(PurposeCheck, Purpose, purpose2IDOptions, 'ID', Purpose2ID)

  initialValues.PurposeSum = getReqAmountRestricted() ? initialValues.ReqAmount : PurposeSum
  initialValues.Purpose2Sum = getReqAmountRestricted() ? 0 : Purpose2Sum

  initialValues.Contribution = Contribution
  initialValues.ManagerID = ManagerID
  // second page end

  // Third page dynamic data
  // initialValues.DynFieldData = paramProps.customFieldsData

  // paramProps.dynamicFieldsList
  initialValues.DynFieldData = Object.keys(paramProps.customFieldsData).reduce(
    (result, key) => ({
      ...result,
      [key]: LKDate.isValidFormat(paramProps.customFieldsData[key])
        ? moment(paramProps.customFieldsData[key], 'YYYY-MM-DD HH:mm:ss', true).format('DD.MM.YYYY')
        : paramProps.customFieldsData[key],
    }),
    {},
  )
  // End -- Third page dynamic data

  // fourth page start
  initialValues.ProjectDescription = ProjectDescription
  initialValues.CField1 = CField1
  initialValues.CField2 = CField2
  initialValues.CField3 = CField3
  initialValues.CField4 = CField4
  // fourth page end

  return { initialValues, additionalValues }
}

export const getFormAndAdditionalInitialValues = (paramProps) => {
  const { params = {} } = paramProps

  if (!isApplicationIdentity(params.applicationIdentity)) {
    return getFormAndAdditionalInitialValuesAdd(paramProps)
  }

  return getFormAndAdditionalInitialValuesEdit(paramProps)
}
